import { get, pickBy } from 'lodash';

const getAdvertiserStatusFromState = (state) => {
  const isAdvertiser = get(state, `serviceProviderCache.${state.serviceProviderId}.isAdvertiser`);
  if (typeof isAdvertiser === 'undefined') {
    return undefined;
  } else if (isAdvertiser) {
    return 'Advertiser';
  }
  return 'NonAdvertiser';
};

const getNorthstarStatusFromState = (state) => {
  const isNorthStar = get(state, `serviceProviderCache.${state.serviceProviderId}.isNorthStar`);
  if (isNorthStar) {
    return 'Yes';
  }
  return 'No';
};

const defaultProps = pickBy({
  userId: '[[user.userInfo.response.userId]]',
  serviceProviderId: '[[serviceProviderId]]',
  href: typeof window !== 'undefined' ? window.location.href : null,
  pathName: typeof window !== 'undefined' ? window.location.pathname : null,
  advertisingStatus: getAdvertiserStatusFromState,
  NorthstarStatus: getNorthstarStatusFromState,
});

const defaultPageProps = pickBy({
  userId: '[[user.userInfo.response.userId]]',
  serviceProviderId: '[[serviceProviderId]]',
  advertisingStatus: getAdvertiserStatusFromState,
  NorthstarStatus: getNorthstarStatusFromState,
});

const defaultIdentifyProps = {
  userId: '[[user.userInfo.response.userId]]',
};

export { defaultProps, defaultPageProps, defaultIdentifyProps };



// WEBPACK FOOTER //
// ./src/app/browser/analyticsDefaultProperties.js